// Тип визы и место получения визы
export function activeRadioTypeOfVisa (proxy)
{
    const data = proxy.data

    let controller = {
        checked: false,
        input: false, // false
        radio: false
    }

    const inputBox = proxy.fvcContainerId.querySelectorAll('.fvc_input_wrapper .fvc_input_left .input_box');

    // Контроль переключения Select
   data.customSelectActive(proxy);

    // Получаем объект с LocalStorage
    const step = 'step'+proxy.data.step;
    const dataLocalStorage = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
    if (dataLocalStorage) {
        proxy.data.setDataFormAddLocalStorage(proxy.data.dataForm[step], dataLocalStorage);
    }

    if (dataLocalStorage.id) {
        setTypeOfVisaBorderRadioId(inputBox, proxy.fvcTextPriceId, controller, proxy);
    }

    if (dataLocalStorage.userConsent && dataLocalStorage.locationVisaRefer) {
        controller.input = true
    }

    // Записываем в radio данные
    data.setTextRadioDataForm(proxy, step);

    // Перезаписываем LocalStorage при выборе с Radio
    data.setRadioClickLocalStorage(proxy);

    // Контроль радио кнопки и добавление активного класса
    proxy.fn.setBorderControlRadioLoad(proxy.fvcContainerId)

    // errorRadiosController(proxy, controller);

    setTypeOfVisaRadioRelatives(proxy, controller);

    setTypeOfVisaCheckboxActiveId(proxy, controller, step, dataLocalStorage);
    getTypeOfVisaBorderRadio(proxy, inputBox, controller, step);

    getTypeOfVisaCheckboxActive(proxy, controller, step);
    clickBtnGetBorderCheckbox(proxy, controller);
}

// При клике на радио кнопки и загрузки страницы
function getTypeOfVisaBorderRadio (proxy, inputBox, controller, step)
{
    const getRadio = proxy.fn.getParams('radio');

    inputBox.forEach((label) =>
    {
        // выбираем радио кнопку по Get параметру
        const input = label.querySelector('input[type=radio]')
        if (input.id === proxy.visual.STEP_ID+'_'+proxy.data.step+'-'+getRadio) {
            input.checked = true;
            eventClickRadio()

            // Удаляем радио параметр
            const url = new URL(document.location);
            const searchParams = url.searchParams;
            searchParams.delete("radio");
            window.history.pushState({}, '', url.toString());
        }

        // Формируем разряд чисел
        // const priceR = label.closest('.fvc_input_wrapper').querySelector('.fvc_price span');
        // priceR.innerText = proxy.data.numberWithSpaces(priceR.innerText) + BX.message('R');

        label.addEventListener('click', eventClickRadio)

        // Клик по радио кнопки
        function eventClickRadio () {
            const fvcInputWrapper = proxy.fvcContainerId.querySelectorAll('.fvc_input_wrapper');

            fvcInputWrapper.forEach((fvcWrapper) => {
                fvcWrapper.classList.remove('active')
            })
            const input = label.querySelector('input[type=radio]');

            if (input.checked) {
                const innerWrapper = input.closest('.fvc_input_wrapper');
                innerWrapper.classList.add('active');

                let dataRadio = {
                    name: innerWrapper.querySelector('.fvc_label').innerText,
                    prise: innerWrapper.querySelector('.fvc_price').innerText,
                    method: innerWrapper.querySelector('.fvc_label').dataset.method,
                }

                const steps = proxy.data.dataForm[step];

                steps.id = proxy.fn.getInputId(proxy, innerWrapper.querySelector('.radio_control_js').id);
                steps.name = dataRadio.name;
                steps.method = dataRadio.method;
                steps.prise = dataRadio.prise;

                // Референс код
                const fvcInputContainer = input.closest('.fvc_input_container')
                const inputControl = fvcInputContainer.querySelector('.input_control_js')
                const inputContainer = fvcInputContainer.querySelector('.input_container');
                const dataName = inputControl.dataset.name;
                proxy.data.dataForm[step][dataName] = false

                proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm[step], proxy.data.step);

                // if (input.id === proxy.stepId + '_' + proxy.data.step + '-5') {
                if (proxy.fn.getInputId(proxy, input.id) === '5') {

                    let referIdF;

                    if (!proxy.data.dataForm.step1.referId) {
                        referIdF = 1
                    } else {
                        referIdF = proxy.data.dataForm.step1.referId
                    }

                    let referId = 'STEP1_REFER_MESSAGE_'+referIdF
                    let fvcLabel = label.querySelector('.fvc_label')
                    fvcLabel.dataset.method = proxy.message[referId]

                    dataRadio.method = proxy.message[referId]

                    inputControl.required = true
                    clickRadioRefCode (proxy, controller, inputControl)
                } else {
                    inputControl.required = false
                    inputControl.value = '';
                    inputContainer.style.display = 'none'
                    controller.input = true;

                    const dataLocalStorage = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
                    dataLocalStorage.referId = false
                    proxy.data.dataForm.step1.referId = false
                    proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm.step1, proxy.data.step);
                }

                proxy.fvcTextPriceId.innerHTML = "";
                proxy.fvcTextPriceId.insertAdjacentHTML("afterbegin", setTypeOfVisaRadioPriceHtml(dataRadio))

                if (!proxy.data.dataForm[step].userConsent) {
                    controller.checked = false;
                }
                setTypeOfVisaButtonActive(proxy, controller);
            }
        }
    });
}

// Если был активирован "Референс код" по клику
function clickRadioRefCode (proxy, controller, inputControl)
{
    controller.input = false
    const fvcInputContainer = inputControl.closest('.fvc_input_container');
    const inputContainer = fvcInputContainer.querySelector('.input_container');

    const dataLocalStorage = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
    const dataName = inputControl.dataset.name;

    if (!dataLocalStorage.referId) {
        dataLocalStorage.referId = '1'
        proxy.data.dataForm.step1.referId = '1'
        proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm.step1, proxy.data.step);
    }

    loadingControlSelectRef(proxy);

    if (dataLocalStorage[dataName]) {
        controller.input = true
        inputControl.value = dataLocalStorage[dataName]
        setTypeOfVisaButtonActive (proxy, controller)
    }

    inputContainer.style.display = 'block'
    const data = {
        controller: controller,
        proxy: proxy
    }

    const referName = fvcInputContainer.querySelector('.custom_select_auto');
    BX.bind(referName, 'click', BX.proxy(eventClickVisaRefer, data));
}

function eventClickVisaRefer ()
{
    const proxy = this.proxy
    const controller = this.controller
    const step = 'step'+proxy.data.step;
    controller.input = false

    // Получаем объект с LC
    const dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

    /*let referIdF;

    if (!dataLS.referId) {
        referIdF = 1
    } else {
        referIdF = dataLS.referId
    }*/

    // let referId = 'STEP1_REFER_MESSAGE_'+referIdF

    // dataLS.method = proxy.message[referId]
    // proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, proxy.data.step);

    proxy.fvcTextPriceId.innerHTML = "";
    proxy.fvcTextPriceId.insertAdjacentHTML("afterbegin", setTypeOfVisaRadioPriceHtml(dataLS))

    setTypeOfVisaButtonActive (proxy, controller)
}

// Событие при заполнении "Место получения Визы по Референс коду"
function eventClickInputLocationVisaRefer (e)
{
    const target = e.target
    const step = 'step'+this.proxy.data.step;
    this.controller.input = false

    const inputContainer = target.closest('.input_container')
    const inputs = inputContainer.querySelectorAll('.input_control_js')
    const formAdditionalText = inputContainer.querySelector('.form_additional_text');

    inputContainer.classList.remove('_error')
    inputContainer.classList.remove('_success')
    if (formAdditionalText) formAdditionalText.remove();

    const required = target.hasAttribute('required');
    const value = target.value.trim();
    const length = value.length;
    const exception = target.dataset.exception;
    const regexPattern = /[0-9]/g;
    const cyrillicPattern = /[^а-яё\d\-\s]/gi;
    const lettersPattern = /[^a-z\d\-\s]/gi;
    const checkLetters = value.match(lettersPattern);

    if (required && !value) {
        this.controller.input = false
    } else if (required && length <= 2) {
        this.controller.input = false
    } else if (required && checkLetters && !exception) {
        this.controller.input = false
    } else if (value && length >= 3) {
        this.proxy.data.dataForm[step][target.dataset.name] = value
        this.controller.input = true
    }

    this.proxy.data.setStepLocalStorage(this.proxy.visual.LOCAL_STORAGE_STEP_ID, this.proxy.data.dataForm[step], this.proxy.data.step);
    this.proxy.data.inputControlClickBtn(inputs, this.proxy)

    setTypeOfVisaButtonActive (this.proxy, this.controller)
}

// Разметка куда дублируется название вида визы и ее цена
function setTypeOfVisaRadioPriceHtml (dataRadio)
{
    return `
        <div class="fvc_visa_type_text flex_c_sb">
            <span class="fvc_vtt_name">${dataRadio.name}:</span>
            <span class="fvc_vtt_price">${dataRadio.prise}</span>
        </div>
        <div class="form_additional_text">
            <i>!</i><span>${dataRadio.method}</span>
        </div>`;
}

// Контролируем при загрузке Select
function loadingControlSelectRef(proxy)
{
    const step = 'step'+proxy.data.step;
    // Получаем объект с LC
    const dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

    if (dataLS.referId) {
        const select = proxy.fvcContainerId.querySelector('.select_wrapper');
        const option = proxy.fvcContainerId.querySelector('.option_wrapper input[value="'+dataLS.referId+'"]');

        if (option) option.checked = true;

        const span = select.querySelector('span');
        const disabled = select.classList.contains('disabled')

        if (disabled) select.classList.remove('disabled')
        span.innerText = proxy.message['STEP1_REFER_'+dataLS.referId];
    }
}

// Отлавливаем нажатый чекбокс
function getTypeOfVisaCheckboxActive (proxy, controller, step)
{
    controller.checked = false;

    const formCheckbox = proxy.fvcContainerId.querySelector('.form_checkbox');
    const input = formCheckbox.querySelector('.form_checkbox input');

    if (input.checked) controller.checked = true;

    input.addEventListener('click', function (e) {
        const dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
        controller.checked = e.target.checked;
        dataLS.userConsent = controller.checked;
        proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, proxy.data.step);

        setTypeOfVisaButtonActive(proxy, controller);
        clickBtnGetBorderCheckbox(proxy, controller);

        if (formCheckbox.classList.contains('border_error')) {
            formCheckbox.classList.remove('border_error')
        }
    });
}

// Выбираем радио кнопку если есть ID
function setTypeOfVisaBorderRadioId (inputBox, textPriceId, controller, proxy)
{
    const dataObj = proxy.data
    const inputControl = proxy.fvcContainerId.querySelector('.input_control_js')
    const inputContainer = inputControl.closest('.input_container');
    const dataName = inputControl.dataset.name;
    const step = 'step'+dataObj.step;

    // Перебираем все типы виз
    inputBox.forEach((label) => {
        // const input = label.querySelector('input[id="'+dataObj.dataForm.step1.id+'"]');
        const inputIdStep = proxy.fn.getInputStepId(proxy, dataObj.dataForm.step1.id)
        const input = label.querySelector('input[id="'+inputIdStep+'"]');

        if (input) {
            const inputWrapper = input.closest('.fvc_input_wrapper');
            input.checked = true;
            inputWrapper.classList.add('active')
            controller.input = true;
            dataObj.dataForm.step1[dataName] = false;

            // Переключатель стоит на "Референс код"
            // const radioId = proxy.stepId + '_' + dataObj.step + '-5';

            // proxy.fn.getInputStepId(proxy, steps.id)
            inputContainer.style.display = 'none'
            if (dataObj.dataForm.step1.id === '5') {

                let referIdF;

                if (!dataObj.dataForm.step1.referId) {
                    referIdF = 1
                } else {
                    referIdF = dataObj.dataForm.step1.referId
                }

                let referId = 'STEP1_REFER_MESSAGE_'+referIdF

                let fvcLabel = label.querySelector('.fvc_label')
                fvcLabel.dataset.method = proxy.message[referId]

                proxy.data.dataForm[step].method = proxy.message[referId]
                proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm[step], proxy.data.step);

                clickRadioRefCode (proxy, controller, inputControl, step)
                controller.input = false;
            }

            textPriceId.innerHTML = "";
            textPriceId.insertAdjacentHTML("afterbegin", setTypeOfVisaRadioPriceHtml(dataObj.dataForm.step1))
        }
    });
}

// Активируем чекбокс
function setTypeOfVisaCheckboxActiveId (proxy, controller, step, dataLocalStorage)
{
    controller.checked = true;
    const steps = proxy.data.dataForm[step];
    steps.userConsent = controller.checked;

    const input = proxy.fvcContainerId.querySelector('.form_checkbox input');

    if (dataLocalStorage.userConsent) {
        input.checked = true;
        setTypeOfVisaButtonActive(proxy, controller);
    } else {
        steps.userConsent = controller.false;
        input.checked = false;
    }
}

// Радио кнопки "родственники в Иране"
function setTypeOfVisaRadioRelatives (proxy, controller)
{
    const radioCustomDws = proxy.fvcContainerId.querySelector('.radio_custom_dws');
    const inputRadios = radioCustomDws.querySelectorAll('input[type=radio]')

    inputRadios.forEach((radio) => {
        if (radio.checked && radio.id === '294') {
            controller.radio = true
        }
        radio.addEventListener('click', eventClickRadio)
    })

    // Клик по радио кнопки
    function eventClickRadio (e) {
        controller.radio = e.target.id === '294';
        setTypeOfVisaButtonActive(proxy, controller);
    }
}

// Активируем кнопку
function setTypeOfVisaButtonActive (proxy, controller)
{
    const btnNext = proxy.btnWrapperId.querySelector('.form_button_wrapper .b_next');

    // Подсветка радио кнопок
    const radioCustomDws = proxy.fvcContainerId.querySelector('.radio_custom_dws');
    if (radioCustomDws.classList.contains('_error')) {
        radioCustomDws.classList.remove('_error')
    }

    if (!controller.radio) {
        radioCustomDws.classList.add('_error')
    }


    if (proxy.data.dataForm.step1.referId > 0 && proxy.data.dataForm.step1.id >= 1) controller.input = true
    if (controller.input && controller.checked && controller.radio) {
        if (btnNext.classList.contains('disabled')) {
            btnNext.classList.remove('disabled');
            btnNext.classList.add('in');
        }
    } else {
        btnNext.classList.add('disabled');
        btnNext.classList.remove('in');
    }
}

// По клику на неактивную кнопку выделяем чекбокс
function clickBtnGetBorderCheckbox (proxy, controller)
{
    const formCheckbox = proxy.fvcContainerId.querySelector('.form_checkbox')
    const btnNextDisabled = proxy.btnWrapperId.querySelector('.form_button_wrapper .b_next.disabled');

    const input = formCheckbox.querySelector('input')

    if (btnNextDisabled) {
        btnNextDisabled.addEventListener('click', function (e) {
            if (!input.checked && !controller.checked) {
                formCheckbox.classList.add('border_error');
            }
        });
    }
}

// Проверяем radio на _error
function errorRadiosController (proxy, controller)
{
    const radios = proxy.fvcContainerId.querySelectorAll('.radio_wrapper_too .radio_control_js');
    let result = false;

    radios.forEach(radio => {
        const error = radio.closest('.radio_wrapper_too._error');
        const success = radio.closest('.radio_wrapper_too._success');

        if (error) {
            result = false;
        } else result = !(!error && !success);
    })

    controller.radio = result;
}